/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Rights_ReservedInputs */

const en_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Rights Reserved`)
};

const es_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los derechos reservados`)
};

/**
* | output |
* | --- |
* | "All Rights Reserved" |
*
* @param {Footer_Rights_ReservedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_rights_reserved = /** @type {((inputs?: Footer_Rights_ReservedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Rights_ReservedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_rights_reserved(inputs)
	return es_footer_rights_reserved(inputs)
});